//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MoominWaveDivider",
  props: {
    color: {
      type: String,
      default: "var(--c-secondary-sand)",
    },
    bottomDivider: {
        type: Boolean,
        default: false
    },
    newWave: {
      type: Boolean,
      default: false
    }
  }
};
